export default __webpack_public_path__ + "static/media/MR.c6d1949c.mp3";